<div class="max-w-layout page-header">
<ng-content />
</div>
